<script>
  import { mapActions } from "vuex";
  import store from "../store";
  import Quantity from "./quantity.vue";
  import { throttle } from "../util";

  export default {
    selector: '#vue-product-form',
    components: { Quantity },
    store,
    props: {
      product: {
        type: Object,
        required: true
      },
      stock: {
        type: Object,
      },
      subscriptionSettings: [Object, Boolean],
      initialVariantId: {
        type: Number,
        required: true
      }
    },
    data() {
      return {
        quantity: 1,
        subscription: this.subscriptionSettings && this.subscriptionSettings.subscriptionFirst,
        selectedVariant: this.initialVariantId,
        // currentFlavour: currentFlavour && currentFlavour.handle
      };
    },
    mounted() {
      this.stickyBar();

      new Shopify.OptionSelectors(`product-${this.product.id}`, {
        product: this.product,
        onVariantSelected: this.onVariantUpdate,
        enableHistoryState: true,
      });

      const subscriptionElement = this.$el.querySelector('[data-subscription]');
      if ( subscriptionElement && subscriptionElement.checked ) {
        this.subscription = true;
      }

      this.$el.addEventListener('change', (e) => {
        const input = e.target

        if ( subscriptionElement ) {
          this.subscription = !!subscriptionElement.checked;
        }

        // Options
        if ( input.hasAttribute('data-select') ) {
          this.updateVariantSelect(input);
        }

        const labels = this.$el.querySelectorAll('label.is-active')
        labels.forEach(item => item.classList.remove('is-active'))
        input.closest('label')?.classList.add('is-active')

        this.updatePrices();
      })

      this.$el.addEventListener('submit', (e) => {
        e.preventDefault();
        this.handleAddClick();
      });

      if (!window.location.search.includes('variant=') && window.preselectOption) {
        const options = window.preselectOption.split(',').map(value => value.trim());

        const matchingEveryVariant = this.product.variants.find(i => i.options.every(i => options.includes(i)));
        const matchingSomeVariant = this.product.variants.find(i => i.options.some(i => options.includes(i)));

        const matchingVariant = matchingEveryVariant || matchingSomeVariant

        if (matchingVariant) {
          const optionInput1 = document.querySelector(`input[data-select="1"][value="${matchingVariant.options[0]}"]`);
          const optionInput2 = document.querySelector(`input[data-select="2"][value="${matchingVariant.options[1]}"]`);
          const optionInput3 = document.querySelector(`input[data-select="3"][value="${matchingVariant.options[2]}"]`);

          if (optionInput1) optionInput1.click()
          if (optionInput2) optionInput2.click()
          if (optionInput3) optionInput3.click()
        }
      }

      window.ProductFormEventsLoaded = true;
      document.dispatchEvent(new CustomEvent('ProductFormEventsLoaded'));
    },

    methods: {
      ...mapActions({
        addToCart: "cart/add"
      }),

      updateVariantSelect(input) {
        const index = input.dataset.index;
        const matchingSelect = this.$el.querySelector(`select[data-option="option${input.dataset.select}"]`);

        matchingSelect.selectedIndex = parseInt(index, 10);
        matchingSelect.dispatchEvent(new Event('change'));
      },

      onVariantUpdate(variant) {
        const price = this.$el.querySelector('[data-price]');
        const comparePrice = this.$el.querySelector('[data-compare]');
        const submit = this.$refs.addToCart;
        const BIS = this.$refs.BIS;

        if ( variant ) {
          this.selectedVariant = variant.id;
          const selectedVariantStock = this.stock.variants.find((variant) => variant.id === this.selectedVariant);
          price.textContent = Shopify.formatMoney(variant.price, Shopify.money_format_currency);

          if ( variant.compare_at_price > variant.price ) {
            comparePrice.hidden = false;
            comparePrice.textContent = Shopify.formatMoney(variant.compare_at_price, Shopify.money_format_currency);
          } else {
            comparePrice.hidden = true;
          }

          if ( variant.available ) {

            if (this.stock.limit < selectedVariantStock.quantity && selectedVariantStock.policy !== 'continue') {
              submit.disabled = false;
              submit.hidden = false;
              BIS.hidden = true;
            } else {
              submit.disabled = true;
              submit.hidden = true;
              BIS.hidden = false;
            }

          } else {
            submit.disabled = true;
            submit.hidden = true;
            BIS.hidden = false;
          }

        } else {
          submit.disabled = true;
          submit.hidden = true;
          BIS.hidden = false;
        }

        this.updatePrices();
      },

      updatePrices() {
        let variants = this.product.variants;
        // if ( this.subscription ) variants = this.subscriptionSettings.product.variants;

        let variant = variants.find(item => item.id === this.selectedVariant);
        let price = variant.price;

        if ( this.subscription ) {
          const discount = variant.price / 100 * this.subscriptionSettings.discountPercentage;
          price = variant.price - discount;
        }

        const subscribePrice = this.$el.querySelector('[data-subscribe-price]');
        const subscribeComparePrice = this.$el.querySelector('[data-subscribe-compare]');

        if (subscribePrice) subscribePrice.textContent = Shopify.formatMoney(variant.price - (variant.price / 100 * this.subscriptionSettings.discountPercentage), Shopify.money_format_currency);
        if (subscribeComparePrice) subscribeComparePrice.textContent = Shopify.formatMoney(variant.price, Shopify.money_format_currency);

        const addPrice = this.$el.querySelectorAll('[data-add-price]');

        addPrice.forEach(item => {
          item.innerHTML = Shopify.formatMoney(price * this.quantity , Shopify.money_format_currency);
        });
      },

      quantityChanged(value) {
        this.quantity = value;
        this.updatePrices();
      },

      stickyBar() {
        const footer = document.querySelector('#shopify-section-footer footer')
        const { quickbuy, addToCart } = this.$refs

        if (quickbuy) {
          this.handleScroll = throttle(() => {
            const top = addToCart.offsetTop;

            if ( window.scrollY > top && ((window.scrollY + window.innerHeight) - quickbuy.offsetHeight) < footer.offsetTop ) {
              document.documentElement.classList.add('sticky-form');
              quickbuy.classList.add('is-sticky');
            } else {
              document.documentElement.classList.remove('sticky-form');
              quickbuy.classList.remove('is-sticky');
            }
          }, 50)

          window.addEventListener('scroll', this.handleScroll)
        }
      },

      handleAddClick() {
        const data = {
          id: this.selectedVariant,
          quantity: this.quantity,
          selling_plan: ''
        }
        const sellingPlan = document.querySelector('input[name="selling_plan"]');
        if (sellingPlan && sellingPlan.value) {
          data.selling_plan = sellingPlan.value
        } else {
          delete data.selling_plan
        }

        this.addToCart(data);
      },

      handleAddSubscription() {
        const variant = this.subscriptionSettings.product.variants.find(
          ({ id }) => id === this.selectedVariant
        );

        if (!variant) {
          console.log('error variant', this.selectedVariant);
        }
        const duplicateId = variant.duplicateId;
        const data = {
          quantity: this.quantity,
          id: duplicateId,
          'properties[shipping_interval_frequency]': this.subscriptionSettings.interval.frequencies[0].toString(),
          'properties[shipping_interval_unit_type]': this.subscriptionSettings.interval.unit,
          'properties[subscription_id]': this.subscriptionSettings.subscriptionId
        };

        this.addToCart(data);
      },

      destroy() {
        window.removeEventListener('scroll', this.handleScroll)
      }
    }
  }
</script>
